// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"PM-z","inlineTitle":"QM-z","sponsoredAdsWrapper":"RM-z","marketplaceRecosWrapper":"SM-z"};